export default "__VITE_ASSET__j61KFAUw__"